import React, { FC, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import classnames from 'classnames'
import { Grid, makeStyles, Theme, Typography } from '@material-ui/core'

import { EventStages, GameFlowSteps, IUser } from 'types'
import { PillButton } from 'components'
import { GameFlowStepsConfig } from 'helpers/steps'

interface IWelcomeProps {
  setScene: (state: GameFlowSteps) => void
  setGameState: (state: GameFlowSteps) => void
  user?: IUser | null
  activeScene: GameFlowSteps
  transition: boolean
  eventStage?: EventStages
}

export const WelcomeScene: FC<IWelcomeProps> = ({ user, setGameState, activeScene, transition, eventStage }) => {
  const history = useHistory()
  const [exit, setExit] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(activeScene === GameFlowSteps.Welcome && transition)
  const classes = useStyles()

  useEffect(() => {
    if (activeScene === GameFlowSteps.Welcome && transition) {
      setTimeout(() => {
        setLoading(false)
      }, GameFlowStepsConfig[GameFlowSteps.Welcome].animation.time)
    }
    return () => {
      setExit(true)
    }
    // eslint-disable-next-line
  }, [])

  const explore = () => {
    history.push('/stream')
  }

  return (
    <>
      {!loading && (
        <div
          id='scene-welcome'
          className={classnames(classes.transition, classes.root, {
            [classes.transitionOut]: exit
          })}
        >
          <Grid container direction='row' justify='center' style={{ maxHeight: '100%' }}>
            {/* <Grid item>
              <Typography classes={{ root: classes.greeting }} component='h4' variant='h4'>
                Hi <span>{user?.firstName}</span>.
              </Typography>
            </Grid> */}
            <Grid item>
              <Typography classes={{ root: classes.heading }} component='h2' variant='h2'>
                Welcome to 5G Innovation Sessions: Advancing the Mission of the DOD
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography component='p' paragraph>
                Defense agencies are looking for ways to become more agile with 5G in an effort to enhance their digital
                transformation initiatives and better support the warfighter.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography component='p' paragraph>
                During this hour-long event, Verizon will explain why 5G matters to the DOD, how it can help securely
                shape missions, and discuss defense-focused use cases.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography component='p' paragraph>
                Additionally, we discuss the path one military base took to deploy 5G and how it is being used to
                support their strategic initiatives.
              </Typography>
            </Grid>
            <Grid item container spacing={1}>
              <Grid item xs={12} sm={6}>
                {eventStage === EventStages.POSTEVENT ? (
                  <PillButton
                    className={classes.button}
                    backgroundColor='transparent'
                    onClick={() => setGameState(GameFlowSteps.EventReplay)}
                  >
                    Watch event replay
                  </PillButton>
                ) : (
                  <PillButton className={classes.button} backgroundColor='transparent' onClick={explore}>
                    Watch live stream
                  </PillButton>
                )}
              </Grid>
            </Grid>
          </Grid>
        </div>
      )}
    </>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: 'calc(100% - 170px)',
    width: 'calc(50% - 32px)',
    padding: '0 12.5%',
    top: '120px',
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    backgroundColor: 'transparent',
    overflowY: 'auto',
    zIndex: 1300,
    color: '#000',

    [theme.breakpoints.down('lg')]: {
      padding: '0 12.5% 0 10%'
    },
    [theme.breakpoints.down('md')]: {
      padding: '0 8%'
    },
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      textAlign: 'left',
      top: '100px',
      height: 'calc(100% - 150px)'
    }
  },
  greeting: {
    fontSize: '1.25rem',
    marginBottom: 16,
    marginTop: 8
  },
  heading: {
    marginBottom: '2rem'
  },
  introZIndex: {
    zIndex: 20000
  },
  intro: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 20000,
    display: 'flex',
    background: '#000',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  button: {
    height: 42,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    margin: '16px 0 0 0',
    whiteSpace: 'nowrap',
    [`${theme.breakpoints.down('sm')}, screen and (max-height: 540px)`]: {
      margin: '2px 0 22px 0'
    }
  },
  inlineButton: {
    color: '#000',
    margin: '0 .5rem',
    fontFamily: 'Verizon-Regular',
    textDecoration: 'underline'
  },
  closeButton: {
    zIndex: 10000,
    position: 'absolute',
    top: '0',
    right: '5px',
    color: 'rgba(255, 255, 255, 0.25)',
    '&:hover': {
      color: 'rgba(255, 255, 255, 0.75)'
    }
  },
  transition: {
    opacity: 1,
    animationName: '$fadeInOpacity',
    animationIterationCount: 1,
    animationTimingFunction: 'ease-in',
    animationDuration: '0.75s'
  },
  transitionOut: {
    animationName: '$fadeOutOpacity',
    animationIterationCount: 1,
    animationTimingFunction: 'ease-out',
    animationDuration: '0.75s',
    opacity: 0
  },
  '@keyframes fadeInOpacity': {
    '0%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  },
  '@keyframes fadeOutOpacity': {
    '0%': {
      opacity: 1
    },
    '100%': {
      opacity: 0
    }
  }
  // ,
  // delay: {
  //   animation: '0s linear 2.3s forwards makeVisible',
  //   visibility: 'hidden'
  // }
}))
